var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-page',{attrs:{"title":_vm.$t('MENU.DASHBOARD'),"layout":"section"}},[(_vm.isStaff)?_c('dashboard-staff'):(_vm.isLegalEntity)?_c('dashboard-legal-entity'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }